import { Flex, List, Progress } from "antd";
import { FC } from "react";

import {
    QueueTaskSnapshot,
    QueueTaskStatus,
} from "@/hooks/core/useAsyncTaskQueue";
import {
    StyledCheckCircleOutlined,
    StyledClockCircleOutlined,
    StyledExclamationCircleOutlined,
    StyledLoadingOutlined,
} from "@/shared/feedback/ProgressLoader/Styled";
import { PrimaryText } from "@/shared/ui";

interface TaskProgressDisplayProps {
    tasks?: QueueTaskSnapshot[];
}

const getStatusIcon = (status: QueueTaskStatus) => {
    switch (status) {
        case QueueTaskStatus.Completed:
            return <StyledCheckCircleOutlined />;
        case QueueTaskStatus.Error:
            return <StyledExclamationCircleOutlined />;
        case QueueTaskStatus.Running:
            return <StyledLoadingOutlined />;
        case QueueTaskStatus.Pending:
        default:
            return <StyledClockCircleOutlined />;
    }
};

export const TaskProgressDisplay: FC<TaskProgressDisplayProps> = ({
    tasks = [],
}) => {
    const photoTasks = tasks.filter((t) => t.label === "photo");
    const restTasks = tasks.filter((t) => t.label !== "photo");

    const photosCompleted = photoTasks.filter(
        (t) =>
            t.status !== QueueTaskStatus.Pending &&
            t.status !== QueueTaskStatus.Running,
    );

    return (
        <>
            {photoTasks.length > 0 && (
                <Flex vertical gap={8}>
                    <Progress
                        percent={Math.ceil(
                            (photosCompleted.length / photoTasks.length) * 100,
                        )}
                        status="active"
                    />

                    <PrimaryText>
                        Завантажено {photosCompleted.length} фото із{" "}
                        {photoTasks.length}
                    </PrimaryText>
                </Flex>
            )}

            {restTasks.length > 0 && (
                <List
                    dataSource={restTasks}
                    renderItem={(task: QueueTaskSnapshot) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={getStatusIcon(task.status)}
                                title={
                                    <PrimaryText fontSize={14} fontWeight="400">
                                        {task.label}
                                    </PrimaryText>
                                }
                            />
                        </List.Item>
                    )}
                />
            )}
        </>
    );
};
